<template>
  <HubContainer id="marketingHub">

    <template v-if="atLeastCompanyAdmin">
      <HubSection large icon="icon/hub/promo.svg" v-if="!$store.getters.isBranchContextInventory"
                  :title="$t('promotions.title')"
                  :description="$t('promotions.subtitle')"
                  :buttonAction="goToPromotionHub">
      </HubSection>

      <HubSection large icon="icon/hub/email-configuration.svg" v-if="moduleActivated.onlineOrdering"
                  :title="$t('advanced_navigation.emails_configuration')"
                  :description="$t('advanced_navigation.emails_configuration_description')"
                  :buttonAction="goToEmail">
      </HubSection>

      <HubSection large icon="icon/hub/sales-report.svg" v-if="!isPosOnly"
                  :title="$t('inventory.upsell')"
                  :description="$t('inventory.upsell_description')"
                  :buttonAction="goToUpsell">
      </HubSection>

      <HubSection large icon="icon/hub/newsletter.svg" v-if="!exactlyDistributor"
                  :title="$t('mailchimp.newsletter')"
                  :description="$t('mailchimp.newsletter_description')"
                  :buttonAction="goToNewsletter">
      </HubSection>

      <HubSection large icon="icon/hub/company.svg" v-if="moduleActivated.onlineOrdering"
                  :title="$t('companies.settings.presentation')"
                  :description="$t('companies.settings.presentation_description')"
                  :buttonAction="goToCompanyPresentation">
      </HubSection>

      <HubSection large icon="icon/hub/role-permission.svg" v-if="moduleActivated.menuBoard && atLeastBranchAdmin"
                  :title="$t('services.menuboard')"
                  :description="$t('services.menuboard')"
                  :buttonAction="goToMenuboard">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "marketingHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.marketing";
      this.$store.state.pageIcon = "/icon/nav/marketing.svg";

      if (this.$route.query.branch) {
        let branchModule = await this.$store.getters.getContextBranchActivatedModule;
        Object.assign(this.moduleActivated, branchModule);
      }

      if (this.$route.query.company) {
        let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
        Object.assign(this.moduleActivated, companyModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      atLeastBranchAdmin() {
        return this.$store.getters.loggedUserHasBranchAdmin;
      },
      atLeastCompanyAdmin() {
        return this.$store.getters.loggedUserHasCompanyAdmin;
      },
      exactlyDistributor() {
        return this.$store.state.loggedUser.isDistributor;
      },
      hasAtLeastOneOnlineOrderingPlatformActive() {
        let validKeys = ["POS", "thirdPartyLoyalty", "loyalty"];
        for (const [key, value] of Object.entries(this.moduleActivated)) {
          if (value && !validKeys.includes(key)) {
            return true;
          }
        }
        return false;
      },
      isPosOnly() {
        return this.moduleActivated.POS && !this.hasAtLeastOneOnlineOrderingPlatformActive;
      }
    },

    methods: {
      goToPromotionHub() {
        this.$router.push(this.$router.buildContext("/promotion-hub"));
      },
      goToEmail() {
        this.$router.push(this.$router.buildContext("/settings/emails"));
      },
      goToUpsell() {
        this.$router.push(this.$router.buildContext("/upsell"));
      },
      goToNewsletter() {
        this.$router.push(this.$router.buildContext("/newsletter"));
      },
      goToCompanyPresentation() {
        this.$router.push(this.$router.buildContext("/settings/presentation"));
      },
      goToMenuboard() {
        this.$router.push(this.$router.buildContext("/settings/services/menu-board"));
      },
    }
  }
</script>